import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, useTheme } from '@material-ui/core/styles';
import { Switch } from '@material-ui/core';
export function MSwitch({ color = 'primary', sx, ...other }) {
    const theme = useTheme();
    if (color === 'default' || color === 'primary' || color === 'secondary') {
        return _jsx(Switch, Object.assign({ color: color, sx: sx }, other), void 0);
    }
    return (_jsx(Switch, Object.assign({ sx: {
            '&.Mui-checked': {
                color: theme.palette[color].main,
                '&:hover': {
                    bgcolor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
                },
            },
            '&.Mui-checked + .MuiSwitch-track': {
                bgcolor: theme.palette[color].main,
            },
            ...sx,
        } }, other), void 0));
}
//# sourceMappingURL=MSwitch.js.map